
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DictionaryUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateDictionaries"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DictionaryUpdateInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryAddInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryUpdateInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addDataTranslationMaps"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataTranslationMapAddInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeDataTranslationMaps"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addServiceTranslationMaps"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceTranslationMapAddInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeServiceTranslationMaps"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dictionaries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateDictionaries"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addCategories"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCategories"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"removeCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeCategoryId"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addDataTranslationMaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataTranslationMaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addDataTranslationMaps"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"removeDataTranslationMaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dataTranslationMapIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeDataTranslationMaps"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addServiceTranslationMaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"serviceTranslationMaps"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addServiceTranslationMaps"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"removeServiceTranslationMaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"serviceTranslationMapIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeServiceTranslationMaps"}}}],"directives":[]}]}}],"loc":{"start":0,"end":1008}};
    doc.loc.source = {"body":"mutation DictionaryUpdate(\n    $updateDictionaries: [DictionaryUpdateInput!]!,\n    $addCategories: [CategoryAddInput!]!,\n    $updateCategories: [CategoryUpdateInput!]!,\n    $removeCategoryId: [ID!]!,\n    $addDataTranslationMaps: [DataTranslationMapAddInput!]!,\n    $removeDataTranslationMaps: [ID!]!,\n    $addServiceTranslationMaps: [ServiceTranslationMapAddInput!]!,\n    $removeServiceTranslationMaps: [ID!]!\n) {\n    updateDictionaries(dictionaries: $updateDictionaries)\n    addCategories(categories: $addCategories) {\n        id\n    }\n    updateCategories(categories: $updateCategories)\n    removeCategories(categoryIds: $removeCategoryId)\n    addDataTranslationMaps(dataTranslationMaps: $addDataTranslationMaps) {\n        id\n    }\n    removeDataTranslationMaps(dataTranslationMapIds: $removeDataTranslationMaps)\n    addServiceTranslationMaps(serviceTranslationMaps: $addServiceTranslationMaps) {\n        id\n    }\n    removeServiceTranslationMaps(serviceTranslationMapIds: $removeServiceTranslationMaps)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DictionaryUpdate"] = oneQuery(doc, "DictionaryUpdate");
        
